var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.show)?_c('div',{staticClass:"cover",on:{"click":_vm.close}},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }